import { render } from "./DynvibeColumn.vue?vue&type=template&id=53937f88"
import script from "./DynvibeColumn.vue?vue&type=script&lang=js"
export * from "./DynvibeColumn.vue?vue&type=script&lang=js"

import "./DynvibeColumn.vue?vue&type=style&index=0&id=53937f88&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__